<template>
  <b-card-code title="">
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <vue-good-table
      id="basicTable"
      v-if="selectedPage === 'general_settings' || selectedPage === 'stages' || selectedPage === 'phases'"
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
      @on-selected-rows-change="selectionChanged"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >
     <span v-if="props.column.label === 'Message' || props.column.label === 'Content'">
          <div style="display: flex; justify-content: center; cursor: pointer;">
            <span  data-toggle="modal" data-target="#contentModal" @click="getElement(props.row)">
               <feather-icon
                  icon="MailIcon"
                  size="16"
                  class="text-body align-middle mr-25"
              />
              </span>
          </div>

       <!--          <span>-->
       <!--            <b-dropdown-->
       <!--                variant="link"-->
       <!--                toggle-class="text-decoration-none"-->
       <!--                no-caret-->
       <!--            >-->
       <!--              <template v-slot:button-content>-->
       <!--                <feather-icon-->
       <!--                    icon="EyeIcon"-->
       <!--                    size="16"-->
       <!--                    class="text-body align-middle mr-25"-->
       <!--                />-->
       <!--              </template>-->
       <!--            </b-dropdown>-->
       <!--          </span>-->
        </span>
        <!-- Column: Name -->
        <span
          v-if="props.column.field === 'Name'"
          class="text-nowrap"
        >
          <b-avatar
            :src="props.row.avatar"
            class="mx-1"
          />
          <span class="text-nowrap">{{ props.row.name }}</span>
        </span>
        <!-- Column: Status -->
        <span style="display:block;" v-else-if="props.column.field === 'status'">
          <b-badge :variant="statusVariant(props.row.status)">
            {{ props.row.status }}
          </b-badge>
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item
                  v-if="$router.currentRoute.name != 'notifications'"

                  data-toggle="modal"
                data-target="#editModal"
                @click="getElement(props.row)"
              >
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Edit</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="$router.currentRoute.name != 'settings' && $router.currentRoute.name != 'notifications'"
                @click="catchId(props.row.id)"
              >
                <feather-icon
                  icon="TrashIcon"
                  class="mr-50"
                />
                <span>Delete</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-for="(action, index) of actionsObj"
                :key="index"
                @click="clickAction(action.title, props.row.id)"
              >
                <feather-icon
                  :icon="action.icon"
                  class="mr-50"
                />

                <span>{{ action.title }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          <span v-if="props.column.label !== 'File' && props.column.label !== 'Message' && props.column.label !== 'Content'">
            <span v-if="props.formattedRow.id === 'PRIVACY' || props.formattedRow.id === 'TERMS'"  data-toggle="modal"
                  data-target="#editModal"
                  @click="getElement(props.row)">
                 <span class="s-hover" v-if="selectedPage === 'general_settings'" > {{ props.formattedRow.id }} </span>
            </span>
                 <span v-else>{{ props.formattedRow[props.column.field] }}</span>

          </span>
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Showing 1 to
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '50', '100']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    <vue-good-table
      v-if="selectedPage !== 'general_settings' && selectedPage !== 'stages' && selectedPage !== 'phases'"
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :select-options="{
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
      @on-selected-rows-change="selectionChanged"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >
        <!-- Column: File -->
        <span v-if="props.column.label === 'File'">
          <div style="display: flex; justify-content: center; cursor: pointer;">
            <a :href="props.formattedRow[props.column.field]" target="_blank">
                             <feather-icon
                                 icon="EyeIcon"
                                 size="16"
                                 class="text-body align-middle mr-25"
                             />
              </a>
          </div>

          <!--          <span>-->
          <!--            <b-dropdown-->
          <!--                variant="link"-->
          <!--                toggle-class="text-decoration-none"-->
          <!--                no-caret-->
          <!--            >-->
          <!--              <template v-slot:button-content>-->
          <!--                <feather-icon-->
          <!--                    icon="EyeIcon"-->
          <!--                    size="16"-->
          <!--                    class="text-body align-middle mr-25"-->
          <!--                />-->
          <!--              </template>-->
          <!--            </b-dropdown>-->
          <!--          </span>-->
        </span>
        <!-- Column: Name -->
        <span
          v-if="props.column.field === 'Name'"
          class="text-nowrap"
        >
          <b-avatar
            :src="props.row.avatar"
            class="mx-1"
          />
          <span class="text-nowrap">{{ props.row.name }}dd</span>
        </span>

        <!-- Column: Status -->
        <span v-else-if="props.column.field === 'status'">
            <div style="display: flex;" v-if ="$router.currentRoute.name === 'transfer-requests' || $router.currentRoute.name === 'cancel-requests'">
           <b-form-checkbox
               v-if="props.row.status !== 'Pending' "
               checked="true"
               class="custom-control-secondary"
               name="check-button"
               switch
               @change="changeStatus(props.row)"
           />
          <b-form-checkbox
              v-else-if="props.row.status === 'Pending' "
              checked="false"
              class="custom-control-secondary"
              name="check-button"
              switch
              @change="changeStatus(props.row)"
          />
            <b-badge v-if ="$router.currentRoute.name === 'transfer-requests' || $router.currentRoute.name === 'cancel-requests'">
            {{ props.row.status }}
          </b-badge>
          </div>
          <div v-else ="$router.currentRoute.name === 'project-contracts'">
           <b-form-checkbox
              v-if="props.row.status === 'inactive' "
              checked="true"
              class="custom-control-secondary"
              name="check-button"
              switch
              @change="changeStatus(props.row)"
            />
          <b-form-checkbox
              v-else-if="props.row.status === 'active' "
              checked="false"
              class="custom-control-secondary"
              name="check-button"
              switch
              @change="changeStatus(props.row)"
          />
          </div>

          <b-badge v-else :variant="statusVariant(props.row.status)">
            {{ props.row.status }}
          </b-badge>
        </span>
        <span v-else-if="props.column.field === 'contract.project.name'&&'$router.currentRoute.name === transfer-requests'">
          {{ props.formattedRow[props.column.field] }}
                 <feather-icon @click="getAction(props.row)" icon="EyeIcon" size="16" class="text-body align-middle mr-25" style="cursor: pointer"/>
        </span>
        <span v-else-if="props.column.field === 'contract.project.name'&&'$router.currentRoute.name === cancel-requests'">
          {{ props.formattedRow[props.column.field] }}
                 <feather-icon @click="getAction(props.row)" icon="EyeIcon" size="16" class="text-body align-middle mr-25" style="cursor: pointer"/>
        </span>
           <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item
                v-if="selectedPage !=='edit-project'"
                data-toggle="modal"
                data-target="#editModal"
                @click="getElement(props.row)"
              >
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Edit</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="selectedPage ==='edit-project'"
                @click="getElement(props.row)"
              >
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Edit</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="selectedPage !== 'general_settings' && selectedPage !== 'stages' && selectedPage !== 'phases'"
                @click="catchId(props.row.id)"
              >
                <feather-icon
                  icon="TrashIcon"
                  class="mr-50"
                />
                <span v-if="$router.currentRoute.name !== 'representatives'">Delete</span>
                <span v-if="$router.currentRoute.name === 'representatives'">UnAssign</span>

              </b-dropdown-item>
              <b-dropdown-item
                v-for="(action, index) of actionsObj"
                :key="index"
                @click="clickAction(action.title, props.row.id)"
              >
                <feather-icon
                  :icon="action.icon"
                  class="mr-50"
                  />

                <span>{{ action.title }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
         <span v-if="props.column.label !== 'File' && props.column.label !== 'Message' && props.column.label !== 'Content'">{{ props.formattedRow[props.column.field] }}</span>
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Showing 1 to
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10','50','100']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    <template #code>
      {{ codeBasic }}
    </template>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BRow, BCol, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, BFormCheckbox
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import store from '@/store/index'
import { codeBasic } from './code'
import { codeColor } from './switchColorCode/code'


export default {
  components: {
    BRow,
    BCol,
    BCardCode,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BFormCheckbox
  },
  directives: {
    Ripple,
  },
  props: ['columns', 'values', 'actionsObj', 'selectedPage'],
  data() {
    return {
      codeColor,
      deletedRows: [],
      showMultipleButton: false,
      pageLength: 10,
      edit_object: '',
      dir: false,
      codeBasic,
      rows: [],
      titles: [],
      searchTerm: '',
      status: [{
        1: 'Current',
        2: 'Professional',
        3: 'Rejected',
        4: 'Resigned',
        5: 'Applied',
      },
      {
        1: 'light-primary',
        2: 'light-success',
        3: 'light-danger',
        4: 'light-warning',
        5: 'light-info',
      }],
    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: 'light-primary',
        Pending      : 'dark-primary',
        Professional: 'light-success',
        Rejected: 'light-danger',
        Resigned: 'light-warning',
        Applied: 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  watch: {
    values(newV, oldV) {
      this.rows = newV
    },
  },
  created() {
    this.rows = this.values
    // this.$http.get('/good-table/basic')
    //   .then(res => { this.rows = res.data })
  },
  mounted() {
    console.log(this.$router.currentRoute.name);
    if (document.getElementById('deleteMultiple') !== null) {
      document.getElementById('deleteMultiple').disabled = true
      document.getElementById('deleteMultiple').style.cursor = 'not-allowed'
    }
    // console.log('Current URL ====>', this.$router.currentRoute)
    // console.log('Current URL ====>', this.$route.params)
    //  console.log('selectedPage====>', this.selectedPage)
  },
  methods: {
    selectionChanged(params) {
      const arr = params.selectedRows.map(el => el.id)
      if (arr.length === 0) {
        document.getElementById('deleteMultiple').disabled = true
        document.getElementById('deleteMultiple').style.cursor = 'not-allowed'
      } else {
        document.getElementById('deleteMultiple').disabled = false
        document.getElementById('deleteMultiple').style.cursor = 'pointer'
        this.$emit('deletedMultipleIds', arr)
      }
    },
    getElement(obj) {
      this.edit_object = obj
      this.$emit('choosenObject', this.edit_object)
    },
    clickAction(key, id) {
      this.$emit('dynamicAction', { key, id })
    },
    catchId(id) {
      const arr = []
      arr.push(id)
      this.$emit('deleteItems', arr)
    },
    confirmText() {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$swal({
            icon: 'success',
            title: 'Deleted!',
            text: 'Your file has been deleted.',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    changeStatus(row) {
      this.$emit('changeStatus', row)
    },
    getAction(row) {
      this.$emit('getAction', row)
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
.s-hover:hover{
  color: #c8a45f;
  cursor: pointer;
}
.vgt-responsive{
  width: 100%;
  overflow-x: inherit!important;
  position: relative;
}
</style>
